var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"input-value":_vm.value,"dense":"","hide-details":"","readonly":_vm.readonly},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }